import Attachment from '@/app/components/UI/Attachment/Attachment'
import { AttachmentProps } from '@/app/models/attachment'
import { BareHtml } from '@components/ActivityExecution/Messaging/Message/BareHtml'
import { UseLinkInterceptor } from '@Techedge/smart-shared'
import { useEffect } from 'react'
import './MainInformation.scss'

const MainInformation = (props: {
    title: string
    description: string
    attachments?: AttachmentProps[]
    cover?: string
}) => {
    const { title, description, attachments, cover } = props

    const componentClass = 'smart-modals-news-execution-main-information'

    const {linkHandler } = UseLinkInterceptor({
        iframeDocument: '',
        mode: sessionStorage.getItem('mode'),
        newApp: sessionStorage.getItem('newApp'),
    })

    useEffect(() => {
        if(description) {
            linkHandler()
        }
    }, [description])

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__title`}>{title}</div>
            {cover && (
                <div className={`${componentClass}__cover`}>
                    <img src={cover} />
                </div>
            )}
            <div className={`${componentClass}__description`}>
                <div className={`${componentClass}__content text`} id="linkInterceptorTarget">
                    <BareHtml.div
                        className="froala-editor-content"
                        innerHTML={{ __html: description }}
                    />
                </div>
            </div>
            {attachments && attachments?.length > 0 && (
                <div className={`${componentClass}__attachments`}>
                    {attachments.map((a: AttachmentProps, i: number) => {
                        return (
                            <div key={i} className={`${componentClass}__attachment`}>
                                {a && (
                                    <Attachment
                                        key={i}
                                        fileUrl={a?.url}
                                        fileName={a?.name}
                                        fileExtension={a?.ext}
                                        showDownloadIcon
                                    />
                                )}
                            </div>
                        )
                    })}
                </div>
            )}
        </div>
    )
}

export default MainInformation
